export const showKeyList = {
  showKey: ["name", "type", "item", "advantage"],
  editKey: ["name", "type", "item", "advantage"]
};
